import { createActions } from 'redux-actions';


const actionCreators = createActions({
    REPORTS: {
        LOADING: {
            ON: undefined,
            OFF: undefined,
        },
        CONNECTING: {
            ON: undefined,
            OFF: undefined,
        },
        EXPORTING: {
            ON: undefined,
            OFF: undefined,
        },
        SESSION: {
            SET: session => session,
            CLEAR: undefined,
        },
        REPORT: {
            SET: report => report,
            CLEAR: undefined,
        },
    },
});

export default actionCreators.reports;
